module.exports = __webpack_public_path__ + "static/media/gold-rush-player-login-bg.2b44d444.jpg";